import { _apiV2_CMS } from "@/app/api2"
import { OppFinder } from "@/app/types"

export async function apiv2_getOppFinder(
  key: string
): Promise<OppFinder | void> {
  try {
    const response = await _apiV2_CMS({
      url: `/oppfinder/${key}`,
      options: { key: "oppfinder" + key },
    })

    return response
  } catch (error) {
    console.error("Error fetching OppFinders:", error)
  }
}
